import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import asyncValidate from './asyncValidate';
import FormFieldsTabChangeLog from '../../form-fields/tab-changelog/tab-changelog';
class EditViewClientTabChangeLog extends Component {
  render() {
    return (
      <div>
         <FormFieldsTabChangeLog {...this.props} locked={this.props.locked} />
      </div>
    );
  }
}
EditViewClientTabChangeLog.propTypes = {
  locked: PropTypes.bool,
}
EditViewClientTabChangeLog = reduxForm({
  form: 'ClientEditForm', // a unique name for this form
  asyncValidate,
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(EditViewClientTabChangeLog);
export default EditViewClientTabChangeLog;